<rt-candidate-sources-typeahead-wrapper
  [sources]="sources"
  [limitItems]="true"
  [withHeading]="withHeading()"
  [withEmptyState]="withEmptyState()"
  [hasNoMargin]="hasNoMargin()"
  (deleteSource)="deleteSource($event)"
  (saveSource)="saveSource($event)"
/>
